import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from '../../../models/utilities/filter-bar';
import { ListColumn, SelectedSort } from '../../../models/utilities/list-header';
import { PageData } from '../../../models/utilities/paged-request';
import { ApiEndpoints, GlobalConstants } from '../../../utils/app-constants';
import { AppUtils } from '../../../utils/app-utils';
import { PickupStatusMetadata } from '../enums/pickup-status';

export class PickupSearchFilters implements IFilterBar {

    public paginationInfo   : PageData;
    public baseUrl          : string = ApiEndpoints.TRANSPORTATION_PICKUPS_SEARCH;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];

    public selectedSort     : SelectedSort;

    constructor() {

        this.columns = [
            new ListColumn('Pickup ID', 'id', true),
            new ListColumn('Status', 'status', true),
            new ListColumn('Dealer', 'dealer', true),
            new ListColumn('Pickup Date', 'date', true),
            new ListColumn('Amount', '', false),
            new ListColumn('Actions', '', false)
        ];

        this.paginationInfo = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);

        // Create our Filter Groups
        const byStatus      = this.buildStatus();
        const byDealer      = this.buildCustomer();
        const byOrder       = this.buildOrder();
        const byDate        = this.buildDate();
        
        this.filters.push(
            byStatus, byDealer, byOrder, byDate
        );
    }

    // #region Group Builders

    private buildStatus() {        
        const byStatus = new FilterGroup('Status', 'checkboxes', 'status');
        byStatus.opts = AppUtils.enumMetadataToFilters(PickupStatusMetadata);
        
        byStatus.opts.forEach((itm : FilterBarInputOpt) => {
            itm.data = (itm.qsValue === 0) ? true : false;
        });

        byStatus.opts = byStatus.opts.filter((itm : FilterBarInputOpt) => {
            return itm.qsValue >= 0;
        });

        return byStatus;
    }

    private buildDate() {
        const byDate = new FilterGroup('Pickup Date', 'date', 'date');        
        const opt1 = new FilterBarInputOpt('Pickup Date', undefined);
        
        byDate.opts = [opt1];

        return byDate;
    }

    private buildCustomer() {
        const byDealer = new FilterGroup('Dealer', 'dealer', 'dealer');
        const opt1 = new FilterBarInputOpt('Dealer', '');
        
        byDealer.opts = [opt1];

        return byDealer;
    }

    private buildOrder() {
        const byOrderId = new FilterGroup('Order Number', 'text', 'order');        
        const opt1 = new FilterBarInputOpt('Order Number', '');
        
        byOrderId.opts = [opt1];

        return byOrderId;
    }

    // #endregion

}
